import React, { Component } from 'react';
import {
  Route,
  Switch,
} from 'react-router-dom';
import './assets/css/App.css'; 
import Header from './modules/sections/Header';
import Nav from './modules/sections/Nav';
import Footer from './modules/sections/Footer';
import Home from './modules/pages/Home';
import About from './modules/pages/About';
import Gigs from './modules/pages/Gigs';
import Video from './modules/pages/Video';
import Photos from './modules/pages/Photos';
import Contact from './modules/pages/Contact';
import PageLoader from './modules/pieces/PageLoader';
import Client from './utils/Client';
import GeneralUtils from './utils/GeneralUtils';

class App extends Component {
  state = {
    showMobileMenu: false,
    siteLoaded: false,
    events: [],
    currEvents: [],
    currMonth: '',
    currYear: '',
    gigMonthChoices: [],
    videos: [],
    photos: []
  }
  componentDidMount(){
    window.onload = (e) => {
      this.setState({siteLoaded: true});
    }
  }
  
  getVideos = () => {
    Client.getMedia(this.setVideos, 'video');
  }
  setVideos = (data) => {
    this.setState({
      videos: data
    })
  }

  getPhotos = () => {
    Client.getMedia(this.setPhotos, 'photos');
  }
  setPhotos = (data) => {
    this.setState({
      photos: data
    })
  }

  getEvents = () => {
    Client.getEvents(this.setEvents);
  }
  getCurrentEvents = (data, month, year) => {
    var currEvents = [];
    for (let value of data){
      
      if(value.Month === month && value.Year == year){
        currEvents.push(value);
      }
    }
    if(currEvents.length === 0){
      var obj = {};
      obj.Month = month,
      obj.Year = year,
      obj.Day = '',
      obj.location = 'No gigs have been scheduled yet for this month. Try another month from the dropdown list above';
      currEvents.push(obj);
    }
    this.setState({
      currEvents: currEvents,
      currMonth: month,
      currYear: year
    })
  }
  getDateChoices = (data) => {
    let choices = [];

    for (let value of data){
      var sysdate = new Date('1' + ' ' + value.Month + ' ' + value.Year).getTime();
      
      if(GeneralUtils.arrayObjectIndexOf(choices, sysdate, 'system_date') === -1){
        var obj = {};
        obj.Month = value.Month;
        obj.Year = value.Year;
        obj.system_date = sysdate;
        choices.push(obj);
      }
    }
    choices = GeneralUtils.sortData(choices, 'system_date');

    this.setState({
      gigMonthChoices: choices
    })
  }
  setEvents = (data, month, year) => {
    data = GeneralUtils.sortData(data, 'event_time');
    this.setState({
      events: data,
      currMonth: month,
      currYear: year,
    })
    this.getCurrentEvents(data, month, year);
    this.getDateChoices(data);
  }
  handleMobileClick = (e) => {
    this.setState({
      showMobileMenu: !this.state.showMobileMenu
    })
  }
  render() {

    return (
      
      
      <div className="page-wrapper">

        {!this.state.siteLoaded && 
          <PageLoader/>
        }
      
      <div className="main-wrapper">
        
        <div className="row content-wrapper">
          <div className="medium-4 large-3 columns side-shade">
            <Header
              handleMobileClick={this.handleMobileClick}
              showMobileMenu={this.state.showMobileMenu}
            />
            <Nav
              handleMobileClick={this.handleMobileClick}
              showMobileMenu={this.state.showMobileMenu}
            />
          </div>
          <div className="medium-8 large-9 columns">
            <div className="main-content">
              <Switch>
                <Route exact path="/" render={(props) => (
                  <Home {...props}
                    
                  />
                )}/>
                <Route exact path="/about" component={About}/>
                <Route exact path="/gigs" render={(props) => (
                  <Gigs {...props}
                    getEvents={this.getEvents}
                    choices={this.state.gigMonthChoices}
                    events={this.state.events}
                    currEvents={this.state.currEvents}
                    currMonth={this.state.currMonth}
                    currYear={this.state.currYear}
                    getCurrentEvents={this.getCurrentEvents}
                  />
                )}/>
                <Route exact path="/video" render={(props) => (
                  <Video {...props}
                    getVideos={this.getVideos}
                    videos={this.state.videos}
                  />
                )}/>
                <Route exact path="/photos" render={(props) => (
                  <Photos {...props}
                    getPhotos={this.getPhotos}
                    photos={this.state.photos}
                  />
                )}/>
                <Route exact path="/contact" component={Contact}/>
              </Switch>
            </div>
          </div>
        </div>
        
        
      </div>
      <div className="footer-wrapper">
        <Footer/>
      </div>
    </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js